import React from 'react';
import styled from '@emotion/styled';
import { Box, Button, Flex } from '@qga/roo-ui/components';
import PropTypes from 'prop-types';

import FlightIcon from '@/components/FlightIcon';
import Heading from '@/components/Heading';
import { FLIGHT_DIRECTION } from '@/constants';

const StyledTab = styled(Button)`
  border-radius: 0;
  border: none;
  background: white;
  padding: 0;
  text-transform: unset;
  letter-spacing: unset;
  font-weight: normal;
  &:hover {
    background: white;
  }
`;

const DirectionTab = React.memo(
  ({ direction, isActive = false, onTabClicked }) => (
    <Box
      flex={['1', null, 'unset']}
      width={[null, null, '149px']}
      pt={[3, null, 3]}
      pb={['6px', null, '6px']}
      borderBottom={isActive ? '4px solid' : '0'}
      borderColor="brand.primary"
      id={`#${direction.toLowerCase()}-tab`}
      data-testid={`${direction.toUpperCase()}_TAB`}
    >
      <StyledTab
        block
        data-testid={`${direction.toUpperCase()}_TAB_BUTTON`}
        onClick={() => onTabClicked()}
      >
        <Flex flexDirection="column" justifyContent="center">
          <Flex justifyContent="center">
            {direction === FLIGHT_DIRECTION.Departing ? (
              <FlightIcon
                direction="departing"
                data-testid={`${direction.toUpperCase()}_FLIGHT_ICON`}
                color={isActive ? 'brand.primary' : 'text.heading'}
                size={25}
              />
            ) : (
              <FlightIcon
                direction="returning"
                data-testid={`${direction.toUpperCase()}_FLIGHT_ICON`}
                color={isActive ? 'brand.primary' : 'text.heading'}
                size={25}
              />
            )}
            <Heading.h5
              pl="2"
              pt="2px"
              color={isActive ? 'brand.primary' : 'text.body'}
              fontSize={['sm', null, '18px']}
            >
              {direction}
            </Heading.h5>
          </Flex>
        </Flex>
      </StyledTab>
    </Box>
  ),
);

DirectionTab.propTypes = {
  direction: PropTypes.string,
  isActive: PropTypes.bool,
  onTabClicked: PropTypes.func.isRequired,
};

export default DirectionTab;
